const ActiveMenuEnum = Object.freeze({
  ASSESSMENT: "Assessment",
  HM: "Homework",
  DSM: "Digital Class Management",
  CM: "Contant Management",
  LM: "Lecture Management",
  CL: "Content Library",
  QL: "Question Library",
  PR: "Pre-read",
  ACTIVITY: "Activity",
  ENGAGEMENT: "Engagement",
  COMMUNITY: "Community",
  STUDENT_QUERY: "Students Query",
  MARK_ATTENDANCE: "Mark Attendance",
  NOTIFY_SHORTAGE: "Notify Shortage",
  REPORT: "Report",
  LEVM: "Leave Management",
  PERFORMANCE: "PERFORMANCE",
  SP: "Student Analytics",
  OPR: "Student Marks Entry (Offline)",
  MS: "My Students",
  TEA_ATT_TODAY: "Teacher attendance today",
  TEA_ATT_HISTORY: "Teacher attendance history",
  TEA_ATT_REPORT: "Teacher attendance report",
  TEA_LEAVE_APPLY: "Apply for leave",
  TEA_LEAVE_LIST: "My leave requests",
  TEA_LEAVE_BALANCES: "Leave balances",
  SALARY_PAYSLIPS: "My payslips",
  REPORT_CARD: "Report Card",
  ACADEMIC_MARKS: "Student Marks Entry (Offline)",
  COMPETENCY_MARKS: "Student Competency  Entry (Offline)",
  OSM_LIST: "Online Script Marking",
  OSM_SETUP: "OSM Setup",
});

export default ActiveMenuEnum;
